import type { ProductType } from '@hc-frontend/core-types';

export function productTypeToReflexive(
  productType: ProductType,
): 'health' | 'medicare' {
  return productType === 'HEALTH' ? 'health' : 'medicare';
}
